module.exports = "https://static.zego.com/_next/static/images/car-b0828128c6bc224573ff6533c9ad54c7.svg";